<template>
  <f7-page class="page-bot-create" @page:init="pageMounted" @page:reinit="pageMounted">
    <f7-navbar :sliding="false">
      <f7-nav-left back-link="Trở lại"></f7-nav-left>
      <f7-nav-title sliding>TẠO BOT AUTO</f7-nav-title>
    </f7-navbar>
    <f7-row class="mb-1">
      <f7-col></f7-col>
      <f7-col>
        <f7-block-title class="mt-0 mb-0 text-align-right text-color-crimson">
          <f7-link @click.prevent="show_help = !show_help">
            Xem hướng dẫn
          </f7-link>
        </f7-block-title>
      </f7-col>
    </f7-row>
    <template v-if="show_help">
      <f7-block strong inset class="alert-warning margin-bottom box-shadow mt-2" v-if="user_info.server_region === 'hanoi'">
        <p>Bước 1:</p>
        <ul>
          <li>Chọn khách hàng bạn muốn liên kết với nhóm bot</li>
          <li>Bật tính năng nhận số đúng chuẩn và trả số dư nếu bạn muốn sử dụng</li>
          <li>Sau đó cài chuẩn nhận số theo ý bạn</li>
        </ul>
        <p>Bước 2: sau đó bấm lưu. Bạn sẽ nhận được 1 dãy <b class="text-color-red">mã liên kết</b>. copy mã liên kết
           này lại.</p>
        <p>Bước 3:</p>
        <ul>
          <li>Vào ứng dụng telegram, bấm chọn tạo nhóm</li>
          <li>Sau đó seach user <b>@kos247_bot</b> add bot vào cùng với khách hàng của bạn. sau đó đặt tên nhóm</li>
        </ul>
        <p>Bước 4 : bấm <b>/ketnoi</b> , nhập <b class="text-color-red">mã liên kết</b> bên trên để kết nối với phòng
           chat.</p>
      </f7-block>
      <f7-block strong inset class="alert-warning margin-bottom box-shadow mt-2" v-else>
        <p>Bước 1:</p>
        <ul>
          <li>Chọn khách hàng bạn muốn liên kết với nhóm bot</li>
          <li>Chọn miền bạn muốn nhận số</li>
          <li>Bật tính năng nhận số đúng chuẩn và trả số dư nếu bạn muốn sử dụng</li>
          <li>Sau đó cài chuẩn nhận số theo ý bạn</li>
        </ul>
        <p>Bước 2: sau đó bấm lưu. Bạn sẽ nhận được 1 dãy <b class="text-color-red">mã liên kết</b>. copy mã liên kết
           này lại.</p>
        <p>Bước 3:</p>
        <ul>
          <li>Vào ứng dụng telegram, bấm chọn tạo nhóm</li>
          <li>Sau đó seach user <b>@kos247_bot</b> add bot vào cùng với khách hàng của bạn. sau đó đặt tên nhóm</li>
        </ul>
        <p>Bước 4 : bấm <b>/ketnoi</b> , nhập <b class="text-color-red">mã liên kết</b> bên trên để kết nối với phòng
           chat.</p>
      </f7-block>
    </template>
    <template v-if="_.isEmpty(result)">
      <f7-list inset inline-labels class="mt-0">
        <f7-list-item title="Khách hàng" smart-select :smart-select-params="{openIn: 'popup', closeOnSelect: true}">
          <select name="customer" @change="changeCustomer($event.target.value)">
            <option value="">- Chọn -</option>
            <optgroup label="Khách">
              <option v-for="(cust, idx) in _.filter(customers, {type: 1})" :key="idx" :value="cust.id" :selected="form_bot.customer_id === cust.id">
                {{ cust.fullname }}
              </option>
            </optgroup>
            <optgroup label="Chủ">
              <option v-for="(cust, idx) in _.filter(customers, {type: 2})" :key="idx" :value="cust.id" :selected="form_bot.customer_id === cust.id">
                {{ cust.fullname }}
              </option>
            </optgroup>
          </select>
          <f7-icon slot="media" ios="f7:person" color="crimson"></f7-icon>
        </f7-list-item>
        <f7-list-input label="Nền tảng" type="select" @input="form_bot.bot_type = $event.target.value">
          <f7-icon slot="media" ios="f7:ant" color="crimson"></f7-icon>
          <option value="telegram">Telegram</option>
        </f7-list-input>
        <f7-list-input label="Cú pháp" type="select" @input="form_bot.play_style = $event.target.value">
          <f7-icon slot="media" ios="f7:gear_alt" color="crimson"></f7-icon>
          <option value="">-- Chọn --</option>
          <option v-for="(item, idx) in (_.find(play_styles, {region: form_bot.region})).items" :key="`play_${idx}`" :value="item.value">
            {{ item.label }}
          </option>
        </f7-list-input>
      </f7-list>
      <template v-if="user_info.server_region !== 'hanoi'">
        <f7-list inset inline-labels>
          <f7-list-item title="Miền Nam">
            <f7-icon slot="media" ios="f7:cube" color="crimson"></f7-icon>
            <f7-toggle slot="after" :checked="form_bot.allow_active_bot.indexOf('mn') >= 0" @toggle:change="toggleActive('mn')"></f7-toggle>
          </f7-list-item>
          <f7-list-item title="Miền Trung">
            <f7-icon slot="media" ios="f7:cube" color="crimson"></f7-icon>
            <f7-toggle slot="after" :checked="form_bot.allow_active_bot.indexOf('mt') >= 0" @toggle:change="toggleActive('mt')"></f7-toggle>
          </f7-list-item>
          <f7-list-item title="Miền Bắc">
            <f7-icon slot="media" ios="f7:cube" color="crimson"></f7-icon>
            <f7-toggle slot="after" :checked="form_bot.allow_active_bot.indexOf('mb') >= 0" @toggle:change="toggleActive('mb')"></f7-toggle>
          </f7-list-item>
        </f7-list>
      </template>
      <f7-list inset inline-labels>
        <f7-list-item title="Nhận tin tự động">
          <f7-icon slot="media" ios="f7:ant" color="crimson"></f7-icon>
          <f7-toggle slot="after" :checked="form_bot.allow_convert_temp_messages.length > 0" @toggle:change="toggleAutoConvert"></f7-toggle>
        </f7-list-item>
      </f7-list>
      <f7-list inset inline-labels>
        <f7-list-item title="Nhận trong chuẩn">
          <f7-icon slot="media" ios="f7:ant" color="crimson"></f7-icon>
          <f7-toggle slot="after" :checked="form_bot.allow_overpoint_limitation.length > 0" @toggle:change="toggleOverpoint"></f7-toggle>
        </f7-list-item>
      </f7-list>
      <f7-list inset inline-labels v-if="form_bot.allow_overpoint_limitation.length > 0">
        <f7-list-item title="Trả số dư qua nhóm khác">
          <f7-icon slot="media" ios="f7:ant" color="crimson"></f7-icon>
          <f7-toggle slot="after" :checked="form_bot.allow_forward_room" @toggle:change="toggleForwardRoom"></f7-toggle>
        </f7-list-item>
      </f7-list>
      <template v-if="form_bot.allow_active_bot.length > 0 && form_bot.allow_overpoint_limitation.length > 0">
        <f7-block-title class="mt-2">CÀI ĐẶT CHUẨN NHẬN SỐ</f7-block-title>
        <template v-if="!!form_bot.customer_id">
          <f7-block inset>
            <f7-segmented raised>
              <f7-button v-if="form_bot.allow_active_bot.indexOf('mn') >= 0" :active="tab_active === 'mn'" @click.prevent="tab_active = 'mn', getBlockNumbers()">
                M.NAM
              </f7-button>
              <f7-button v-if="form_bot.allow_active_bot.indexOf('mt') >= 0" :active="tab_active === 'mt'" @click.prevent="tab_active = 'mt', getBlockNumbers()">
                M.TRUNG
              </f7-button>
              <f7-button v-if="form_bot.allow_active_bot.indexOf('mb') >= 0" :active="tab_active === 'mb'" @click.prevent="tab_active = 'mb', getBlockNumbers()">
                M.BẮC
              </f7-button>
            </f7-segmented>
          </f7-block>
          <div class="pb-2">
            <template v-if="tab_active === 'mn'">
              <ConfigOverPointNgheAn v-if="form_bot.play_style.indexOf('_ngan') >= 0" :region="'mn'" :key="`mn-ovp-ngan`" :play-style="form_bot.play_style" :cust-id="form_bot.customer_id" v-on:updatedConfig="submitForm" ref="configOverPoint"></ConfigOverPointNgheAn>
              <ConfigOverPointBmt v-else-if="form_bot.play_style.indexOf('_buonme') >= 0" :region="'mn'" :key="`mn-ovp-buonme`" :play-style="form_bot.play_style" :cust-id="form_bot.customer_id" v-on:updatedConfig="submitForm" ref="configOverPoint"></ConfigOverPointBmt>
              <ConfigOverPointHanoi v-else-if="form_bot.play_style.indexOf('_hanoi') >= 0" :region="'mn'" :key="`mn-ovp-hanoi`" :play-style="form_bot.play_style" :cust-id="form_bot.customer_id" v-on:updatedConfig="submitForm" ref="configOverPoint"></ConfigOverPointHanoi>
              <ConfigOverPointDefault v-else :enable-block-number="true" :region="'mn'" :key="`mn-ovp-default`" :play-style="form_bot.play_style" :cust-id="form_bot.customer_id" v-on:updatedConfig="submitForm" ref="configOverPoint"></ConfigOverPointDefault>
            </template>
            <template v-else-if="tab_active === 'mt'">
              <ConfigOverPointNgheAn v-if="form_bot.play_style.indexOf('_ngan') >= 0" :region="'mt'" :key="`mt-ovp-ngan`" :play-style="form_bot.play_style" :cust-id="form_bot.customer_id" v-on:updatedConfig="submitForm" ref="configOverPoint"></ConfigOverPointNgheAn>
              <ConfigOverPointBmt v-else-if="form_bot.play_style.indexOf('_buonme') >= 0" :region="'mt'" :key="`mt-ovp-buonme`" :play-style="form_bot.play_style" :cust-id="form_bot.customer_id" v-on:updatedConfig="submitForm" ref="configOverPoint"></ConfigOverPointBmt>
              <ConfigOverPointHanoi v-else-if="form_bot.play_style.indexOf('_hanoi') >= 0" :region="'mt'" :key="`mt-ovp-hanoi`" :play-style="form_bot.play_style" :cust-id="form_bot.customer_id" v-on:updatedConfig="submitForm" ref="configOverPoint"></ConfigOverPointHanoi>
              <ConfigOverPointDefault v-else :enable-block-number="true" :region="'mt'" :key="`mt-ovp-default`" :play-style="form_bot.play_style" :cust-id="form_bot.customer_id" v-on:updatedConfig="submitForm" ref="configOverPoint"></ConfigOverPointDefault>
            </template>
            <template v-else-if="tab_active === 'mb'">
              <ConfigOverPointNgheAn v-if="form_bot.play_style.indexOf('_ngan') >= 0" :region="'mb'" :key="`mb-ovp-ngan`" :play-style="form_bot.play_style" :cust-id="form_bot.customer_id" v-on:updatedConfig="submitForm" ref="configOverPoint"></ConfigOverPointNgheAn>
              <ConfigOverPointBmt v-else-if="form_bot.play_style.indexOf('_buonme') >= 0" :region="'mb'" :key="`mb-ovp-buonme`" :play-style="form_bot.play_style" :cust-id="form_bot.customer_id" v-on:updatedConfig="submitForm" ref="configOverPoint"></ConfigOverPointBmt>
              <ConfigOverPointHanoi v-else-if="form_bot.play_style.indexOf('_hanoi') >= 0" :region="'mb'" :key="`mb-ovp-hanoi`" :play-style="form_bot.play_style" :cust-id="form_bot.customer_id" v-on:updatedConfig="submitForm" ref="configOverPoint"></ConfigOverPointHanoi>
              <ConfigOverPointDefault v-else :enable-block-number="true" :region="'mb'" :key="`mb-ovp-default`" :play-style="form_bot.play_style" :cust-id="form_bot.customer_id" v-on:updatedConfig="submitForm" ref="configOverPoint"></ConfigOverPointDefault>
            </template>
          </div>
        </template>
        <f7-block v-else inset class="mt-1">
          <f7-button fill color="primary" disabled>CHỌN KHÁCH HÀNG</f7-button>
        </f7-block>
      </template>
      <f7-block v-else inset class="mt-1">
        <f7-button fill color="primary" @click.prevent="submitForm">XÁC NHẬN</f7-button>
      </f7-block>
    </template>
    <template v-else>
      <f7-block class="mt-0 mb-0" inset strong>
        <h3 class="text-align-center">MÃ LIÊN KẾT BOT CỦA BẠN LÀ</h3>
        <div class="list form-list no-margin margin-bottom-half">
          <ul>
            <li class="item-content item-input item-input-with-value">
              <div class="item-inner">
                <div class="item-input-wrap">
                  <input type="text" class="input-with-value" @focus="$event.target.select()" :value="result.data.connect_code"/>
                </div>
              </div>
              <div class="item-media">
                <button type="button" @click.prevent="copyClipboard(result.data.connect_code)" class="button button-44 text-color-theme margin-half">
                  <f7-icon f7="doc_on_doc"></f7-icon>
                </button>
              </div>
            </li>
          </ul>
        </div>
      </f7-block>
      <f7-block class="mt-0 mb-0" inset strong v-if="result.data.config.allow_forward_room">
        <h3 class="text-align-center">MÃ LIÊN KẾT PHÒNG TRẢ SỐ DƯ</h3>
        <div class="list form-list no-margin margin-bottom-half">
          <ul>
            <li class="item-content item-input item-input-with-value">
              <div class="item-inner">
                <div class="item-input-wrap">
                  <input type="text" class="input-with-value" @focus="$event.target.select()" :value="result.data.room_forward_code"/>
                </div>
              </div>
              <div class="item-media">
                <button type="button" @click.prevent="copyClipboard(result.data.room_forward_code)" class="button button-44 text-color-theme margin-half">
                  <f7-icon f7="doc_on_doc"></f7-icon>
                </button>
              </div>
            </li>
          </ul>
        </div>
      </f7-block>
    </template>
  </f7-page>
</template>
<script>
import { mapState } from 'vuex';
import ConfigOverPointDefault from "@/pages/Message/components/ConfigOverPointDefault.vue";
import ConfigOverPointBmt from "@/pages/Message/components/ConfigOverPointBmt.vue";
import ConfigOverPointNgheAn from "@/pages/Message/components/ConfigOverPointNgheAn.vue";
import ConfigOverPointHanoi from "@/pages/Message/components/ConfigOverPointHanoi.vue";

export default {
  components: { ConfigOverPointNgheAn, ConfigOverPointBmt, ConfigOverPointDefault, ConfigOverPointHanoi },
  data() {
    return {
      tab_active: 'mn',
      form_bot: {
        customer_id: '',
        bot_type: 'telegram',
        region: 'mn',
        play_style: '',
        allow_active_bot: ['mn'],
        allow_convert_temp_messages: ['mn', 'mt', 'mb'],
        allow_overpoint_limitation: [],
        allow_forward_room: false
      },
      regions: [
        {
          label: 'Miền Nam',
          value: 'mn'
        },
        {
          label: 'Miền Bắc',
          value: 'mb'
        },
        {
          label: 'Miền Trung',
          value: 'mt'
        }
        ],
      play_styles: [
        {
          region: 'mn',
          items: []
        },
        {
          region: 'mb',
          items: []
        },
        {
          region: 'mt',
          items: []
        }
      ],
      result: {},
      show_help: false,
    }
  },
  computed: {
    ...mapState(['customers', 'selected_customer', 'user_info'])
  },
  methods: {
    changeCustomer(cust_id) {
      this.$store.state.selected_customer = this._.find(this.customers, { id: parseInt(cust_id) });
      this.form_bot.customer_id = cust_id;
    },
    submitForm() {
      let self = this;

      if (self._.isEmpty(self.form_bot.customer_id)){
        this.$f7.dialog.alert('Vui lòng chọn Khách hàng', 'LỖI!');
        return false;
      }

      if (self._.isEmpty(self.form_bot.play_style)) {
        this.$f7.dialog.alert('Vui lòng chọn Loại cú pháp', 'LỖI!');
        return false;
      }

      if (self._.isEmpty(self.form_bot.allow_active_bot)) {
        this.$f7.dialog.alert('Vui lòng kích hoạt ít nhất 1 miền', 'LỖI!');
        return false;
      }

      this.$f7.dialog.preloader();

      this.$store.dispatch('generateBotChatRoom', this.form_bot).then((res) => {
        self.result = res;
        this.$f7.dialog.close();
      }).catch((err) => {
        this.$f7.dialog.close();
        this.$f7.dialog.alert(err, 'LỖI!');
      });
    },
    pageMounted() {
      if (this.user_info.server_region === 'hanoi') {
        this.tab_active = 'mb';
        this.form_bot.region = 'mb';
        this.form_bot.play_style = 'mb_hanoi';
        this.form_bot.allow_active_bot = ['mb'];
        this.play_styles[1].items = [{
          label: 'Hà Nội',
          value: 'mb_hanoi'
        }];
      } else {
        if (this.user_info.user_configs.display_mn) {
          this.play_styles[0].items.push({
            label: 'Sài Gòn',
            value: 'default'
          });
        }
        if (this.user_info.user_configs.display_mn_mtay) {
          this.play_styles[0].items.push({
            label: 'Miền Tây',
            value: 'mn_mtay'
          });
        }
        if (this.user_info.user_configs.display_mt) {
          this.play_styles[2].items.push({
            label: 'Sài Gòn',
            value: 'default'
          });
        }
        if (this.user_info.user_configs.display_mt_mtay) {
          this.play_styles[2].items.push({
            label: 'Miền Tây',
            value: 'mn_mtay'
          });
        }
        if (this.user_info.user_configs.display_mb) {
          this.play_styles[1].items.push({
            label: 'Sài Gòn',
            value: 'default'
          });
        }
        if (this.user_info.user_configs.display_mb_mtay) {
          this.play_styles[1].items.push({
            label: 'Miền Tây',
            value: 'mn_mtay'
          });
        }
      }
    },
    showToastBottom(text) {
      const self = this;
      if (!self.toastBottom) {
        self.toastBottom = self.$f7.toast.create({
          text: text,
          closeTimeout: 2000,
          position: 'bottom',
          horizontalPosition: 'center'
        });
      }
      self.toastBottom.open();
    },
    copyCode() {
      this.$copyText(this.result.data.connect_code);
      this.showToastBottom('Đã copy');
    },
    copyClipboard(data) {
      this.$copyText(data);
      this.showToastBottom('Đã copy');
    },
    toggleActive(region){
      let idx = this.form_bot.allow_active_bot.indexOf(region);
      if (idx >= 0){
        this.form_bot.allow_active_bot.splice(idx, 1);
      } else {
        this.form_bot.allow_active_bot.push(region);
      }
      if (!this._.isUndefined(this.form_bot.allow_active_bot[0])){
        this.tab_active = this.form_bot.allow_active_bot[0];
        this.getBlockNumbers();
      }
    },
    toggleAutoConvert() {
      if (this.form_bot.allow_convert_temp_messages.length){
        this.form_bot.allow_convert_temp_messages = [];
      } else {
        this.form_bot.allow_convert_temp_messages = ['mn', 'mt', 'mb'];
      }
    },
    toggleOverpoint() {
      if (this.form_bot.allow_overpoint_limitation.length) {
        this.form_bot.allow_overpoint_limitation = [];
      }
      else{
        this.form_bot.allow_overpoint_limitation = ['mn', 'mt', 'mb'];
        this.getBlockNumbers();
      }
    },
    toggleForwardRoom() {
      this.form_bot.allow_forward_room = !this.form_bot.allow_forward_room;
    },
    getBlockNumbers(){
      let self = this;
      setTimeout(function(){
        self.$refs.configOverPoint.getBlockNumbers();
      }, 200);
    }
  }
};
</script>
